// extracted by mini-css-extract-plugin
module.exports = {"root":"WSNKB","labelcbx":"_3WB8q","checkbox":"_2xESh","invisible":"_1jhH5"};